module.exports = __webpack_public_path__ + "img/spjgc.bebcdc91.png";